import Grid from "@mui/material/Grid";

import useWindowDimensions from "../../../../../../hooks/useWindowDimensions";
import dataCards from "../../data/CardsData.json";
import { AdvantageDesktopCard } from "./components/DesktopCard";
import { AdvantageMobileCard } from "./components/MobileCard";
import { CardProps } from "./types";

const MOBILE_BREAKPOINT = 720;

export const AdvantageCards = () => {
  const { width } = useWindowDimensions();
  const cards = dataCards.cardsData as CardProps[];

  const isMobile = width <= MOBILE_BREAKPOINT;

  return (
    <Grid container spacing={{ xs: 4, sm: 6, md: 8, lg: 10 }}>
      {cards.map((card) => (
        <Grid
          key={`advantage_${card.id}`}
          size={{ xs: 12, sm: 6, md: 4, lg: 4 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {isMobile ? (
            <AdvantageMobileCard {...card} />
          ) : (
            <AdvantageDesktopCard {...card} />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default AdvantageCards;